"use client";

import { useSearchParams, useRouter } from "next/navigation";
import { useEffect } from "react";
import { useAuth } from "./useAuth";
import { useModal } from "@/contexts/modal-context";

export const useConsumeReferral = () => {
  const searchParams = useSearchParams();
  const { address, isAuthenticated } = useAuth();
  const { showReferralModal } = useModal();
  const router = useRouter();

  useEffect(() => {
    // Check for referralCode in URL params or localStorage
    const referralCodeFromUrl = searchParams?.get("referralCode");
    const referralCodeFromStorage = typeof window !== "undefined"
      ? localStorage.getItem("referralCode")
      : null;

    const referralCode = referralCodeFromUrl || referralCodeFromStorage;

    if (!referralCode) {
      return;
    }

    // Store in localStorage if it's from URL
    if (referralCodeFromUrl && typeof window !== "undefined") {
      localStorage.setItem("referralCode", referralCodeFromUrl);
    }

    // Remove from URL to clean the address bar
    if (referralCodeFromUrl && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      params.delete("referralCode");

      const newSearch = params.toString();
      const newPath = window.location.pathname + (newSearch ? `?${newSearch}` : "");

      router.replace(newPath);
    }

    // Show modal if user is authenticated
    if (address && isAuthenticated) {
      showReferralModal();
    }
  }, [searchParams, address, isAuthenticated, showReferralModal, router]);

  return null;
};
